declare namespace $ {

	type $mol_view__sub_bog_bzrl_app_card_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_bzrl_app_card_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_image__uri_bog_bzrl_app_card_3 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_card['photo'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_view__sub_bog_bzrl_app_card_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_bzrl_app_card_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_bzrl_app_card_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_bzrl_app_card extends $mol_view {
		district( ): string
		district_title( ): string
		Badge( ): $mol_view
		checkmark_icon( ): string
		Checkmark( ): $mol_view
		photo( ): string
		Photo( ): $mol_image
		details_text( ): string
		Details( ): $mol_view
		price( ): string
		Price( ): $mol_view
		Info( ): $mol_view
		attr( ): ({ 
			'bog_bzrl_app_card_district': ReturnType< $bog_bzrl_app_card['district'] >,
		})  & ReturnType< $mol_view['attr'] >
		area( ): string
		floor( ): string
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=card.view.tree.d.ts.map